import React from 'react';
import '../styles/Info.css';
import { useTranslation } from 'react-i18next';
import { LuYoutube, LuInstagram } from 'react-icons/lu';
import { SiNaver } from 'react-icons/si';
import { Helmet } from 'react-helmet-async';

export default function Info() {
  const { t, i18n } = useTranslation();

  const nameData = {
    kr: "한지우",
    en: "Han Ji-woo",
    jp: "ハン・ジウ",
    ch: "韓馶友"
  };

  const currentLang = i18n.language.toLowerCase();
  const mainName = nameData[currentLang] || nameData.kr;
  
  const otherNames = Object.values(nameData).filter(name => name !== mainName);

  return (
    <>
      <Helmet>
        <title>배우 한지우 정보</title>
        <meta
          name="description"
          content="배우 한지우의 정보 및 공식 채널 정보를 확인하실 수 있습니다."
        />
        <link rel="canonical" href="https://hanjiwoo.com/info" />
      </Helmet>

      <div className="contact-page-wrapper">
        <div className="sub-page-container contact-page">
          <header className="info-header">
            {/* <p className="info-page-kicker">ACTOR PROFILE</p> */}
            <h1 className="section-title">{t('nav_info')}</h1>
          </header>

          <div className="contact-content-grid">
            <section className="info-main-card profile-styled-card">
              <div className="card-top-accent" />

              <div className="card-inner">
                <div className="profile-hero">
                  <div className="profile-name-block">
                    <p className="profile-overline">PROFILE</p>
                    <h2 className="name-kr">{mainName}</h2>
                    <div className="name-multilang-wrap">
                      {otherNames.map((name, idx) => (
                        <React.Fragment key={idx}>
                          <span className="name-sub">{name}</span>
                          {idx < otherNames.length - 1 && <span className="name-dot">•</span>}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>

                  <div className="profile-summary-badge">
                    <span>ACTOR</span>
                  </div>
                </div>

                <div className="card-divider" />

                <div className="profile-detail-list">
                  <div className="detail-row">
                    <span className="detail-label">{t('info_debut')}</span>
                    <div className="detail-value">
                      <p className="detail-main">2020. 12. 03</p>
                      <p className="sub-text">{t('debut')}</p>
                    </div>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">{t('info_phy')}</span>
                    <div className="detail-value">
                      <p className="detail-main">166cm · 47kg</p>
                    </div>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">{t('info_skill')}</span>
                    <div className="detail-value">
                      <div className="skills-container">
                        <span className="skill-tag">#{t('info_action')}</span>
                        <span className="skill-tag">#{t('info_boxing')}</span>
                        <span className="skill-tag">#{t('info_running')}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-divider" />

                <div className="profile-social-wrap">
                  <p className="social-title">{t('info_channel')}</p>

                  <div className="profile-social-simple">
                    <a
                      href="https://instagram.com/z.wo_o"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-link"
                      aria-label="Instagram"
                    >
                      <LuInstagram />
                    </a>

                    <a
                      href="https://www.youtube.com/@naneunjiwoo"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-link"
                      aria-label="YouTube"
                    >
                      <LuYoutube />
                    </a>

                    <a
                      href="https://cafe.naver.com/creditjiwoo"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-link"
                      aria-label="Naver Cafe"
                    >
                      <SiNaver />
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}